import React from 'react';
import { NavLink } from 'react-router-dom';
import './AppFooter.css';

function AppFooter() {
	return (
		<footer className="site-footer">
			<div className="footer-grid container">
				{/* <div>
					<h6>Explore</h6>
					<ul>
						<ul>
							<li><NavLink to="/" className="footer-nav-link">🏠 Go to Home</NavLink></li>
							<li><NavLink to="/info" className="footer-nav-link">🔍 Intro to Signs & Deaf Community</NavLink></li>
							<li><NavLink to="/learn" className="footer-nav-link">📘 Learn Signs</NavLink></li>
							<li><NavLink to="/practice" className="footer-nav-link">📷 Practice Signing</NavLink></li>
							<li><NavLink to="/tools" className="footer-nav-link">🛠️ Use Sign Lookup Tool</NavLink></li>
							<li><NavLink to="/games" className="footer-nav-link">🎮 Play Sign Games</NavLink></li>
							<li><NavLink to="/simulator" className="footer-nav-link">🧠 Try the Deaf Simulator</NavLink></li>

						</ul>
					</ul>
				</div> */}

				<div className="footer-legal">
					<div className="legal-links">
						<NavLink to="/privacy" className="legal-link">Privacy Policy</NavLink>
						<span>|</span>
						<NavLink to="/terms" className="legal-link">Terms of Use</NavLink>
					</div>
					<p className="copyright">
						© {new Date().getFullYear()} SignMates. All rights reserved. Created with ❤️ for inclusive learning.
					</p>
				</div>

			</div>
		</footer>
	);
}

export default AppFooter;
